import type { RootState } from '../configureStore'

export const selectConfig = (state: RootState) => state.portal.config
export const selectSelectedTheme = (state: RootState) => state.portal.selectedTheme
export const selectRequiredChain = (state: RootState) => state.portal.requiredChain
